import { render, staticRenderFns } from "./RecentRecordGrid.vue?vue&type=template&id=13980577&scoped=true"
import script from "./RecentRecordGrid.vue?vue&type=script&lang=js"
export * from "./RecentRecordGrid.vue?vue&type=script&lang=js"
import style0 from "./RecentRecordGrid.vue?vue&type=style&index=0&id=13980577&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13980577",
  null
  
)

export default component.exports